import { render, staticRenderFns } from "./detail_personalLecture.vue?vue&type=template&id=2b7ab3e7&scoped=true&"
import script from "./detail_personalLecture.vue?vue&type=script&lang=js&"
export * from "./detail_personalLecture.vue?vue&type=script&lang=js&"
import style0 from "./detail_personalLecture.vue?vue&type=style&index=0&id=2b7ab3e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ab3e7",
  null
  
)

export default component.exports